var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:"button",staticClass:"button responsive-font-size",class:{ disabled: _vm.disabled },style:(_vm.coloursStyle),on:{"click":_vm.clicked}},[_vm._v(" "+_vm._s(_vm.buttonText)+" "),_c('div',{staticClass:"icon"},[_c('svg',{attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":_vm.iconPath}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }